import { HorizontalScrollObserver } from "./HorizontalScrollObserver";

export function LoadHorizontalScrollObserver() {
    (window as any).observeHorizontalScrollByRef = function (ref: HTMLElement) {
        if (!ref)
            return;

        let observer = (window as any).ItemsManager.get(ref);

        if (!observer) {
            observer = new HorizontalScrollObserver();
            (window as any).ItemsManager.add(ref, observer);
        }

        observer.observe(ref);
    };

    (window as any).scrollHorizontalToSelectedByRef = function (ref: HTMLElement) {
        if (!ref)
            return;

        const observer = (window as any).ItemsManager.get(ref);

        if (!observer)
            return;

        observer.scrollToSelected("smooth");
    };

    (window as any).unobserveHorizontalScrollByRef = function (ref: HTMLElement) {
        if (!ref)
            return;

        const observer = (window as any).ItemsManager.get(ref);

        if (observer) {
            observer.dispose();
            (window as any).ItemsManager.remove?.(ref);
        }
    };
}